package tta.destinigo.talktoastro.feature_chat_consultation_new.persentation.chat_waiting_room

sealed class ChatWaitingEvent {
    data class ConnectToExpert(val uid:String, val onError:(String)->Unit, val onSuccess:()->Unit):
        ChatWaitingEvent()
    data object CloseThis: ChatWaitingEvent()
    data class StartConsultation(val expertUid:String): ChatWaitingEvent()
}